import {
  Table,
  Button,
  Switch,
  Popconfirm,
  Tooltip,
  Avatar,
  Input,
  notification,
  Spin,
} from "antd";
import * as React from "react";
import { get } from "lodash";
import { getAllNeedyFamily } from "../../Graphs/NeedyFamily/listNeedyFamily";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  DollarCircleOutlined,
  EyeOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { deleteNeedyFamily } from "../../Graphs/NeedyFamily/deleteNeedyFamily";
import { searchNeedyFamily } from "../../Graphs/NeedyFamily/searchNeedyFamily";
import { assignSocialWorker } from "../../Graphs/NeedyFamily/assignSocialWorker";
import { AddSocialWorkerModal } from "./AddSocialWorkerModal";
import { AvailableCreditModal } from "./AvailableCreditModal";
import { ViewVoucherModal } from "./ViewVoucherModal";
import { changeStatus } from "../../Graphs/User/ChangeStatus";
import { editUser } from "../../Graphs/User/editUser";
import { EditModal } from "../NeedyFamily/EditModal";

var moment = require("moment");

class UserRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedNeedyFamily = this.getLimitedNeedyFamily.bind(this);
  }

  modalRef;
  avilableModalRef;
  assignedModalRef;
  editModalRef;

  showEditModal(item) {
    this.setState(
      {
        userSelectedEditData: item,
      },
      () => {
        this.editModalRef.show();
      }
    );
  }

  handleEditModalclose() {
    this.setState({
      userSelectedEditData: null,
    });
  }

  showModal(item) {
    this.setState(
      {
        userSelectedData: item,
        // isOpen: true
      },
      () => {
        this.modalRef.show();
      }
    );
  }

  handleDetailsModalclose() {
    this.setState({
      userSelectedData: null,
    });
  }

  showAvailableModal(item) {
    this.setState(
      {
        userSelectedAvailableData: item,
        // isOpen: true
      },
      () => {
        this.avilableModalRef.show();
      }
    );
  }

  handleDetailsAvailableModalclose() {
    this.setState({
      userSelectedAvailableData: null,
    });
  }

  showAssignedModal(item) {
    this.setState(
      {
        userSelectedAssignedData: item,
        // isOpen: true
      },
      () => {
        this.assignedModalRef.show();
      }
    );
  }

  handleDetailsAssignedModalclose() {
    this.setState({
      userSelectedAssignedData: null,
    });
  }

  async componentDidMount() {
    this.setState({
      data: this.props.data,
      isLoading: false,
      userSelectedData: null,
      userSelectedAvailableData: null,
    });
  }

  async getLimitedNeedyFamily(pagination) {
    const { searchText } = this.props;
    console.log("tempCounter && counter --> ", this.tempCounter, this.counter);
    const start =
      pagination.current * pagination.pageSize - pagination.pageSize;
    const end = pagination.pageSize;

    this.setState(
      {
        isLoading: true,
        startIndex: start,
        limitNumber: end,
      },
      async () => {
        if (searchText != null && searchText !== "") {
          //get search text props from redux store
          this.listSearchNeedyFamilyData(start, end);
        } else {
          //call normal user Data
          this.listNeedyFamilyData(start, end);
        }
      }
    );
  }

  listSearchNeedyFamilyData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListUserData,
        setListUserDataTotal,
        searchText,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let userData = await searchNeedyFamily(authToken, searchText, start, end);

      if (userData.status === 200) {
        //set user Data
        await setListUserData(userData.data);
        await setListUserDataTotal(userData.total);

        this.setState({
          isLoading: false,
          data: userData.data,
        });
      } else if (userData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list search user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  listNeedyFamilyData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListUserData,
        setListUserDataTotal,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let userData = await getAllNeedyFamily(authToken, start, end);

      if (userData.status === 200) {
        //set user Data
        await setListUserData(userData.data);
        await setListUserDataTotal(userData.total);

        this.setState({
          isLoading: false,
          data: userData.data,
        });
      } else if (userData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  dateFormat(date) {
    var oldDate = new Date(),
      momentObj = moment(oldDate).utc(),
      newDate = momentObj.format("Do MMM YYYY");

    return newDate;
  }

  capitalizeFirstLetter(string) {
    return (
      string.charAt(0).toUpperCase() + String(string.slice(1)).toLowerCase()
    );
  }

  capitalizeFirstLetterOfEveryWord(string) {
    let returnString = "";
    let arrayString = string.split(" ");
    arrayString.map((data, index) => {
      if (index == arrayString.length - 1) {
        returnString =
          returnString +
          data.charAt(0).toUpperCase() +
          String(data.slice(1)).toLowerCase();
      } else {
        returnString =
          returnString +
          data.charAt(0).toUpperCase() +
          String(data.slice(1)).toLowerCase() +
          " ";
      }
    });
    return returnString;
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      width: 80,
      render: (text, item, index) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        );
      },
    },
    {
      title: "NRIC/FIN",
      key: "SingpassId",
      width: 100,
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="NRIC/FIN">
                <div>{item.singpass_id ? item.singpass_id : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Name",
      key: "Name",
      width: 140,
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Name">
                <div>
                  {item.user_metadata ? item.user_metadata.principal_name : "-"}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Email",
      key: "Email",
      width: 160,
      render: (text, item, index) => {
        return (
          <div>
            <Tooltip placement="bottom" title="Email">
              <div>
                {item.user_metadata
                  ? item.user_metadata.email
                    ? item.user_metadata.email
                    : "-"
                  : "-"}
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Mobile Number",
      key: "Mobile Number",
      width: 150,
      render: (text, item, index) => {
        return (
          <div>
            <Tooltip placement="bottom" title="Mobile Number">
              <div>
                {item.user_metadata
                  ? item.user_metadata.mobile_number
                    ? item.user_metadata.mobile_number
                    : "-"
                  : "-"}
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Assigned Supervisor",
      key: "social_worker",
      width: 250,
      render: (text, item, index) => {
        let worekerString = "";
        if (item.familyUserForWorker && item.familyUserForWorker.length > 0) {
          item.familyUserForWorker.map((data, index) => {
            let workerUser = data["workerUserForFamily"];
            if (workerUser && workerUser.first_name) {
              if (index === item.familyUserForWorker.length - 1) {
                worekerString = worekerString + workerUser.first_name;
              } else {
                worekerString = worekerString + workerUser.first_name + ", ";
              }
            } else {
              if (index === item.familyUserForWorker.length - 1) {
                worekerString = worekerString + "SocialWorker";
              } else {
                worekerString = worekerString + "SocialWorker" + ", ";
              }
            }
          });
        }
        return (
          <div>
            <Tooltip placement="bottom" title="Assigned Supervisor">
              <div>{worekerString ? worekerString : "-"}</div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Address",
      key: "Address",
      render: (text, item, index) => {
        let addressString = "";
        if (item.user_metadata && item.user_metadata.address) {
          try {
            let addressJson = JSON.parse(item.user_metadata.address);
            if (addressJson.floor && addressJson.floor.value) {
              addressString =
                addressString +
                this.capitalizeFirstLetter(addressJson.floor.value) +
                ", ";
            }

            if (addressJson.block && addressJson.block.value) {
              addressString =
                addressString +
                this.capitalizeFirstLetter(addressJson.block.value) +
                ", ";
            }

            if (addressJson.building && addressJson.building.value) {
              addressString =
                addressString +
                this.capitalizeFirstLetter(addressJson.building.value) +
                ", ";
            }

            if (addressJson.street && addressJson.street.value) {
              addressString =
                addressString +
                this.capitalizeFirstLetter(addressJson.street.value) +
                ", ";
            }

            if (addressJson.postal && addressJson.postal.value) {
              addressString =
                addressString +
                this.capitalizeFirstLetter(addressJson.postal.value) +
                ", ";
            }

            if (addressJson.country && addressJson.country.value) {
              addressString =
                addressString +
                this.capitalizeFirstLetter(addressJson.country.desc);
            }
          } catch (e) {
            addressString = item.user_metadata.address;
          }
        }
        return (
          <div>
            <Tooltip placement="bottom" title="Address">
              <div>
                {addressString
                  ? this.capitalizeFirstLetterOfEveryWord(addressString)
                  : "-"}
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "HouseHold Size",
      key: "HouseHoldSize",
      width: 150,
      render: (text, item, index) => {
        return (
          <div>
            <Tooltip placement="bottom" title="HouseHold Size">
              <div>
                {item.household_size ? String(item.household_size) : "-"}
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "isActive",
      key: "isActive",
      render: (text, item, index) => {
        return (
          <div>
            {item.is_active != null ? (
              <Tooltip placement="bottom" title="Beneficiary Activation">
                {
                  <Switch
                    checked={item.is_active}
                    style={{
                      backgroundColor: item.is_active
                        ? this.props.primaryColor
                        : "#bababa",
                    }}
                    onChange={this.onChange.bind(this, item)}
                  />
                }
              </Tooltip>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      width: 220,
      key: "action",
      render: (text, item, index) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Tooltip placement="bottom" title="Edit">
              <Button
                shape="circle"
                icon={<EditOutlined />}
                onClick={() => {
                  this.showEditModal(item);
                }}
              />
            </Tooltip>
            <Tooltip placement="bottom" title="Assign Supervisor">
              <Button
                shape="circle"
                icon={<CheckCircleOutlined />}
                onClick={() => {
                  this.showModal(item);
                }}
              />
            </Tooltip>
            <Tooltip placement="bottom" title="Assigned e-Voucher Details">
              <Button
                shape="circle"
                icon={<EyeOutlined />}
                onClick={() => {
                  this.showAssignedModal(item);
                }}
              />
            </Tooltip>
            <Tooltip placement="bottom" title="Available Credits by Category">
              <Button
                shape="circle"
                icon={<DollarCircleOutlined />}
                onClick={() => {
                  this.showAvailableModal(item);
                }}
              />
            </Tooltip>
            <Popconfirm
              onConfirm={this.deleteNeedyFamily.bind(this, item)}
              title="Are you sure you want to delete this beneficiary?"
            >
              <Button shape="circle" icon={<DeleteOutlined />} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  async onChange(item, checked) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changeStatus(authToken, item.id, checked);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Change Beneficiary Status",
          description: "Successfully changed status",
        });
        if (searchText != null && searchText !== "") {
          this.listSearchNeedyFamilyData(startIndex, limitNumber);
          return;
        }
        this.listNeedyFamilyData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Change Beneficiary Status",
        description: typeof e === "string" ? e : "Something went wrong",
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  async deleteNeedyFamily(item) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let deleteData = await deleteNeedyFamily(authToken, item.id);

      if (deleteData.status === 200) {
        notification["success"]({
          message: "Delete User",
          description: "Successfully deleted",
        });

        if (searchText != null && searchText !== "") {
          this.listSearchNeedyFamilyData(startIndex, limitNumber);
          return;
        }
        this.listNeedyFamilyData(startIndex, limitNumber);
      } else if (deleteData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Delete User",
        description: typeof e === "string" ? e : "Something went wrong",
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedNeedyFamily(pagination)
    );
  }

  editSubmit = async (userObject, userId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await editUser(authToken, userObject, userId);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit Beneficiary",
          description: "Successfully edited",
        });
        if (searchText != null && searchText !== "") {
          this.listSearchNeedyFamilyData(startIndex, limitNumber);
          return;
        }
        this.listNeedyFamilyData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Beneficiary",
        description: typeof e === "string" ? e : "Something went wrong",
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  assignSocialWokrerSubmit = async (userObject, familyUserId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await assignSocialWorker(
        authToken,
        userObject,
        familyUserId
      );
      if (statusData.status == 200) {
        notification["success"]({
          message: "USER",
          description: "Successfully Assigned",
        });
        if (searchText != null && searchText != "") {
          this.listSearchNeedyFamilyData(startIndex, limitNumber);
          return;
        }
        this.listNeedyFamilyData(startIndex, limitNumber);
      } else if (statusData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        throw statusData && statusData.message ? statusData.message : "Error";
      }
    } catch (e) {
      notification["error"]({
        message: "USER",
        description: typeof e === "string" ? e : "Something went wrong",
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  render() {
    const { isLoading, data } = this.state;
    const { listUserData, listUserDataTotal, searchLoader, authToken } =
      this.props;

    return isLoading || searchLoader ? (
      <div style={{ marginLeft: "20px" }}>
        <Spin
          size="large"
          style={{ marginLeft: "480px", marginTop: "130px" }}
        />
      </div>
    ) : (
      <div style={{ "overflow-x": "auto" }}>
        <Table
          loading={this.state.isLoading}
          rowKey={(record) => record._id}
          columns={this.columns}
          size={"small"}
          scroll={{ x: 1450 }}
          // dataSource={this.state.data}
          dataSource={listUserData}
          pagination={{
            total: listUserDataTotal,
            showSizeChanger: true,
            pageSize: this.state.pagination.pageSize,
            current: this.state.pagination.current,
            pageSizeOptions: ["1", "10", "25", "50", "100"],
            onChange: (e) => {
              console.log("onChanges pagination");
              // e - 1
              //   ? (this.counter = this.tempCounter =
              //       (e - 1) * this.state.pagination.pageSize)
              //   : ((this.counter = 0), (this.tempCounter = 0));
              if (e - 1) {
                this.counter = this.tempCounter =
                  (e - 1) * this.state.pagination.pageSize;
                return;
              }

              this.counter = 0;
              this.tempCounter = 0;
            },
          }}
          onChange={this.handleTableChange}
        />
        {this.state.userSelectedEditData ? (
          <EditModal
            admin={false}
            refx={(e) => (this.editModalRef = e)}
            onClose={this.handleEditModalclose.bind(this)}
            userSelectedData={this.state.userSelectedEditData}
            onSubmit={this.editSubmit}
            authToken={authToken}
          />
        ) : null}
        {this.state.userSelectedData ? (
          <AddSocialWorkerModal
            admin={false}
            refx={(e) => (this.modalRef = e)}
            onClose={this.handleDetailsModalclose.bind(this)}
            userSelectedData={this.state.userSelectedData}
            onSubmit={this.assignSocialWokrerSubmit}
            authToken={authToken}
          />
        ) : null}
        {this.state.userSelectedAvailableData ? (
          <AvailableCreditModal
            refx={(e) => (this.avilableModalRef = e)}
            onClose={this.handleDetailsAvailableModalclose.bind(this)}
            userSelectedAvailableData={this.state.userSelectedAvailableData}
            authToken={authToken}
          />
        ) : null}
        {this.state.userSelectedAssignedData ? (
          <ViewVoucherModal
            refx={(e) => (this.assignedModalRef = e)}
            onClose={this.handleDetailsAssignedModalclose.bind(this)}
            userSelectedAssignedData={this.state.userSelectedAssignedData}
            authToken={authToken}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  listUserData: state.user.listUserData,
  listUserDataTotal: state.user.listUserDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListUserData: (listUserData) => {
      dispatch({
        type: "SET_LIST_USER_DATA",
        listUserData: listUserData,
      });
    },
    setListUserDataTotal: (listUserDataTotal) => {
      dispatch({
        type: "SET_LIST_USER_DATA_TOTAL",
        listUserDataTotal: listUserDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserRecordsTable));
